import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';


const IncomeExpenseDetails = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [ExpenseHeadOptions, setExpenseHeadOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedExpenseId, setselectedExpenseId] = useState(null);
    const [Remarks, setRemarks] = useState('');
    const [type, setType] = useState("");

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchmaxbillno(true);
    }, [isAuthenticated, companyId, token, logout]);

    const fetchOptions = async () => {

        try {
            const response = await fetchData('ExpenseHeadApi', `/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setExpenseHeadOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };
    const handleInputChange = (newValue) => newValue;
    // Handle Expense Head selection
    const handleExpenseHeadSelect = (selectedOption) => {
        setSelectedOption(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            ExpenseHeadId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        if (!selectedOption) return;
        setselectedExpenseId(selectedOption.value);
    };


    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [formData, setFormData] = useState({
        CompanyId: companyId,
        BranchId: branchId,
        BillDate: "", // Or set to today's date
        Remarks: "",
        Amount: "",
        IsIncome: 0, // Default to "Income"
        BillNumber: "",
        createdBy: userId,
        isSubmit: false,
    });

    const [selectedPaymentType, setSelectedPaymentType] = useState(1);
    const [selectedPaymentOrReceipt, setSelectedPaymentOrReceipt] = useState(true);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
            userId: userId,
          
        }));

    };

    let Inputstring = true;
    const fetchmaxbillno = (Inputstring) => {
        // Use the parameter directly, no need to rely on formData here
        fetchData('IncomeExpenseApi', `/MaxBillno/${companyId}/${branchId}/${Inputstring}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                // Update formData with the fetched data
                setFormData((prevData) => ({
                    ...prevData,
                    BillNumber: data.BillNumber,
                    BillDate: formattedDate,
                   
                    BranchId: branchId,
                    CompanyId: companyId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Max Billno:', error);
            });
    };

    useEffect(() => {
        fetchmaxbillno(true);
    }, []);


    const submitData = async (e) => {
        setIsLoading(true);

        const updatedFormData = {
            ...formData,
            CreatedBy: userId,
            ExpenseHeadId: selectedExpenseId,
            BillNo: formData.BillNumber,
            IsIncome: type,
        };

        try {
            const response = await postData('IncomeExpenseApi', updatedFormData, token);
            setSuccessMessage('Receipt Created successfully!');
            setErrorMessage('');

            history.push('/PaymentReceiptIndex');
            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);

        } catch (error) {
            console.error('Receipt Create error:', error);
            if (error.response) {
                console.error('Response data:', error.response.data);
                console.error('Response status:', error.response.status);
                console.error('Response headers:', error.response.headers);
            } else if (error.request) {
                console.error('Request was made but no response received:', error.request);
            } else {
                console.error('Error in setting up the request:', error.message);
            }
            setErrorMessage('Failed to create receipt. Please try again.');
            setIsLoading(false);
        }
    };


    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);



    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    // FOR Current Date and Time 
    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,
            BillDate: formattedDate,
            PaymentType: 1,
        }));
    }, []);



    return (
        <Fragment>

            <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '90%', overflow: 'auto' }}>
                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.5em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                        
                        
                    `}
                </style>

                <div >
                    <div className='w-full flex' style={{ marginTop: '10px' }}>

                        <h6 className="productHead flex-grow linkcolorBlack" style={{ fontFamily: 'Times new romans', fontWeight: 'bolder' }}>CREATE INCOME AND EXPENSE</h6>
                     
                        <Button
                            // style={{ marginLeft: '8px', color: 'darkgreen' }}
                            style={{
                                background: 'linear-gradient(to right, #C7FFD8,#C7FFD8)',
                                color: 'black',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                //marginLeft: '5px',
                                marginLeft: '15px',

                            }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : <b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Save</b>}
                        </Button>

                        <Button
                            color="error"
                            component={Link}
                            to={{
                                pathname: "/PaymentReceiptIndex",
                                state: { from: "/PaymentReceiptCreate" },
                            }}
                            onClick={() => {
                                localStorage.setItem('shouldReload', 'true');
                            }}
                            className="linkcolor"
                            // style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                            style={{
                                background: 'linear-gradient(to right, #FFAAAA,#FFAAAA)',
                                color: 'black',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                //marginLeft: '5px',
                                marginLeft: '15px',

                            }}
                        >
                            <CloseIcon style={{ color: '#A91D3A', fontWeight: 'bolder' }} /><b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Cancel</b>
                        </Button>
                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                        <div className="w-full mb-2 flex flex-wrap" style={{ marginTop: '20px' }}>
                            <div className="w-full sm:w-2/5 pr-2 mb-2 sm:mb-0">
                            
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="customer">
                                    ExpenseHead
                                    <span className="text-red-500">*</span>
                                </label>
                                <AsyncSelect
                                    cacheOptions
                                    loadOptions={fetchOptions}
                                    onInputChange={handleInputChange}
                                    onChange={handleExpenseHeadSelect}
                                    value={selectedOption}
                                />
                            </div>

                            <div className="w-full sm:w-1/5 pl-2 hidden sm:block">
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                    Bill Date
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formatDateForInput(formData.BillDate)}
                                    type="date"
                                    placeholder="Enter Reference Date"
                                    name='BillDate'
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="w-full sm:w-1/5 pl-2 hidden sm:block">
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                    Bill Number
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={`${formData.BillNumber || ''}/${formData.FinYear || ''}`}
                                    type="text"
                                    placeholder="Enter BillNo"
                                    name='BillNo'
                                    readOnly
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="w-full mb-2 flex flex-wrap">


                            <div className="w-full sm:w-1/5 pl-2  sm:block">
                                <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="Amount">
                                    Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Amount}
                                    type="text"
                                    placeholder="Enter Amount"
                                    onChange={handleChange}
                                    name='Amount'
                                    max={formData.TotalBalAmt}
                                    style={{ textAlign: 'right' }}
                                />
                            </div>
                            <div className="w-full sm:w-2/5 pl-2  sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="Remarks">
                                    Remarks
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    name="Remarks"
                                    placeholder="Enter Remarks"
                                    value={Remarks}
                                    onChange={(e) => setRemarks(e.target.value)}
                                />
                            </div>

                            <div className="flex items-center">
                                    <input
                                        type="radio"
                                        id="expense"
                                        name="type"
                                        value="1"
                                        checked={type === '1'}
                                        onChange={(e) => setType(e.target.value)}
                                        className="mr-2"
                                    />
                                   <label className="block tracking-wide text-gray-700 font-bold" style={{ color: 'darkblue' }}>Expense</label>
                                    <input
                                        type="radio"
                                        id="income"
                                        name="type"
                                        value="0"
                                        checked={type === '0'}
                                        onChange={(e) => setType(e.target.value)}
                                        className="mr-2"
                                    />
                                    <label className="block tracking-wide text-gray-700 font-bold ml-2" style={{ color: 'brown' }}>Income</label>
                                </div>

                        </div>
                    </div>
                </div>

        </Fragment>
    );
}

export default IncomeExpenseDetails;
